import UltMeta, { Meta } from "./UltMeta/index";

// 客户端业务类型
class Business_PC extends UltMeta {
    // 进销存
    CONTRACT = new Meta(1, "合同");
    GOODS = new Meta(2, "订单");
    RECEIPT = new Meta(3, "签收");
    RECONCILIATION = new Meta(4, "结算");
    STOCKTAKING = new Meta(5, "盘点");
    STOCK = new Meta(6, "抽检");
    OUTBOUND = new Meta(7, "出库");
    // 仓储
    STOCK_CONTRACT = new Meta(8, "合同");
    STOCK_STOCKTAKING = new Meta(9, "盘点");
    STOCK_STOCK_CHECK = new Meta(10, "抽检");
    STOCK_INBOUND = new Meta(11, "入库");
    STOCK_OUTBOUND = new Meta(12, "出库");

    // 仓储管理
    STORE_CONTRACT = new Meta(14, "合同");
    STORE_STOCKTAKING = new Meta(15, "盘点");
    STORE_STOCK_CHECK = new Meta(16, "抽检");
    STORE_INBOUND = new Meta(17, "入库");
    STORE_OUTBOUND = new Meta(18, "出库");
}

export const BUSINESS_PC = new Business_PC();

// 供应链端业务类型
class Business extends UltMeta {
    // 进销存
    CONTRACT = new Meta(1, "合同");
    GOODS = new Meta(2, "订单");
    RECEIPT = new Meta(3, "签收");
    RECONCILIATION = new Meta(4, "结算");
    STOCKTAKING = new Meta(5, "盘点");
    STOCK = new Meta(6, "抽检");
    OUTBOUND = new Meta(7, "出库");
    // 仓储业务
    STOCK_CONTRACT = new Meta(8, "合同");
    STOCK_STOCKTAKING = new Meta(9, "盘点");
    STOCK_STOCK_CHECK = new Meta(10, "抽检");
    STOCK_INBOUND = new Meta(11, "入库");
    STOCK_OUTBOUND = new Meta(12, "出库");
    TRANSFER = new Meta(13, "过户");

    // 仓储管理
    STORE_CONTRACT = new Meta(14, "合同");
}

export const BUSINESS = new Business();

class Style extends UltMeta {
    OFFICIAL_SEAL = new Meta(1, "公章");
    SPECIAL_SEAL_WITH_STAR = new Meta(2, "专用章(带五角星)");
    SPECIAL_SEAL_WITHOUT_STAR = new Meta(3, "专用章(不带五角星)");
}
export const STYLE = new Style();

// 印章类型枚举
class SealType extends UltMeta {
    PURCHASE_SALES_INVENTORY_SEAL = new Meta(1, "进销存印章");
    WAREHOUSE_SEAL = new Meta(2, "仓储业务印章");
    WAREHOUSE_MANAGE = new Meta(3, "仓储管理印章");
}
export const SEAL_TYPE = new SealType();
